module.exports = __webpack_public_path__ + "static/desktop/img/step-mobile-album.47c7c65c.png";